"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _useStaticInfo = require("./browser/hooks/useStaticInfo");

/* eslint-disable import/no-dynamic-require */
var OriginalSuspense = React.Suspense;

function Suspense(_ref) {
  var key = _ref.key,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["key", "children"]);
  return typeof document !== 'undefined' ? React.createElement(OriginalSuspense, (0, _extends2["default"])({
    key: key
  }, rest), children) : React.createElement(React.Fragment, {
    key: key
  }, children);
} // Override the suspense module to be our own


React.Suspense = Suspense;
React["default"].Suspense = Suspense;

var App = require("".concat(process.env.REACT_STATIC_ENTRY_PATH))["default"];

var _default = function _default(staticInfo) {
  return function (props) {
    return React.createElement(_useStaticInfo.staticInfoContext.Provider, {
      value: staticInfo
    }, React.createElement(App, props));
  };
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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